export default "__VITE_ASSET__Bka$nknp__"